import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'cir-pub-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

  public loginUrl: string;

  constructor() {
    this.loginUrl = environment.privateAppUrl;
  }

  ngOnInit() { }

}
